const hml = 'hml';
const prd = 'prd';
//sistema back-end

export const getBaseUrl = () => {
    switch (process.env.REACT_APP_STAGE) {
        case hml:
            return 'http://homologacao.sefaz.mt.gov.br';
        case prd:
            return 'https://www.sefaz.mt.gov.br';
        default:
            return 'http://localhost:3000';
  }
};

export const getBackEndUrl = () => {
    console.log("ENVIRONMENT: " + process.env.REACT_APP_STAGE)
    console.log("CONTEXT: " + process.env.REACT_APP_CONTEXT)

    switch (process.env.REACT_APP_STAGE) {
        case hml:
            return 'https://homologacao.sefaz.mt.gov.br';
        case prd:
            return 'https://www.sefaz.mt.gov.br';
        default:
            console.log("Host fe-api local: http://localhost:" + process.env.REACT_APP_LOCAL_PORT_FE_API)
            return "http://localhost:" + process.env.REACT_APP_LOCAL_PORT_FE_API;
    }
}


export const getMTloginUrl = () => {
    switch (process.env.REACT_APP_STAGE) {
        case hml:
            return 'https://hml.login.mt.gov.br';
        case prd:
            return 'https://login.mt.gov.br';
        default:
            return 'https://hml.login.mt.gov.br';
  }
};



